'use strict';
import ngMaterial from 'angular-material';
import BrandAgreementsController from './brand-agreements.controller';
import BrandAgreementsService from './brand-agreements.service';
export default angular.module('directives.brandAgreements', [ngMaterial, 'dialog'])
    .service('BrandAgreementsService', BrandAgreementsService)
    .component('brandAgreements', {
    template: require('./brand-agreements.html'),
    controller: BrandAgreementsController,
    controllerAs: 'ba'
})
    .name;
//# sourceMappingURL=index.js.map